// One voice sample at a time, across every card and the samples modal.
// Native <audio controls> would let two players run together; this is the
// single place that decides who is allowed to make sound.

let current = null;
const listeners = new Set();

const notify = () => {
  listeners.forEach((fn) => fn(current));
};

export const subscribePlayback = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const currentPlayback = () => current;

export const claimPlayback = (audio) => {
  if (!audio) return;

  if (current && current !== audio) {
    try {
      current.pause();
    } catch (e) {
      // A player that has already unmounted is not our problem.
    }
  }

  current = audio;
  notify();
};

export const releasePlayback = (audio) => {
  if (current !== audio) return;

  current = null;
  notify();
};

export const stopAllPlayback = () => {
  if (!current) return;

  try {
    current.pause();
  } catch (e) {
    // already gone
  }

  current = null;
  notify();
};
